import type { RouteRecordRaw } from 'vue-router'

const aiAgentRoutes: RouteRecordRaw[] = [
  {
    path: 'ai-agent',
    name: 'ai-agent',
    meta: {
      titleKey: 'routes.ai-agent.title',
      icon: 'MagicStick',
      helpKey: 'ai_agent'
    },
    redirect: { name: 'ai-agent-conversations' },
    children: [
      {
        path: 'conversations',
        name: 'ai-agent-conversations',
        component: () => import('@/views/ai-agent/AiConversations.vue'),
        meta: { titleKey: 'routes.ai-agent.conversations.title', helpKey: 'ai_agent_conversations' }
      },
      {
        path: 'knowledge',
        name: 'ai-agent-knowledge',
        component: () => import('@/views/ai-agent/KnowledgeBase.vue'),
        meta: { titleKey: 'routes.ai-agent.knowledge.title', helpKey: 'ai_agent_knowledge' }
      },
      {
        path: 'config',
        name: 'ai-agent-config',
        component: () => import('@/views/ai-agent/AiConfig.vue'),
        meta: { titleKey: 'routes.ai-agent.config.title', helpKey: 'ai_agent_config' }
      },
      {
        // T-074：缓存管理页（指令→动作组缓存的观测与治理；权限 admin.read / admin.write）
        path: 'cache',
        name: 'ai-agent-cache',
        component: () => import('@/views/ai-agent/AiCache.vue'),
        meta: { titleKey: 'routes.ai-agent.cache.title', helpKey: 'ai_agent_cache' }
      }
    ]
  }
]

export default aiAgentRoutes
